export default __webpack_public_path__ + "static/media/location.8482eb14.svg";